import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button
} from "@mui/material";

import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";

function Biometric() {

  const navigate = useNavigate();

  const cards = [

    {
      title: "Student Biometric",
      desc: "Manage and view student biometric attendance records.",
      icon: <SchoolIcon sx={{ fontSize: 50 }} />,
      color: "#4caf50",
      link: "/student-biometric"
    },

    {
      title: "Teachers Biometric",
      desc: "Track teachers fingerprint attendance and reports.",
      icon: <PersonIcon sx={{ fontSize: 50 }} />,
      color: "#2196f3",
      link: "/teacher-biometric"
    },

    {
      title: "Staff Biometric",
      desc: "Monitor staff biometric attendance.",
      icon: <GroupsIcon sx={{ fontSize: 50 }} />,
      color: "#ff9800",
      link: "/staff-biometric"
    },

    {
      title: "Parents Biometric",
      desc: "Manage parent biometric entry and attendance.",
      icon: <FamilyRestroomIcon sx={{ fontSize: 50 }} />,
      color: "#9c27b0",
      link: "/parent-biometric"
    }

  ];

  return (

    <Box sx={{ p: 4, background: "#f5f7fb", minHeight: "100vh" }}>

      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        gutterBottom
      >
        Biometric Attendance System
      </Typography>

      <Grid className="row" spacing={3} mt={2}>

        {cards.map((item, index) => (

          <Grid className="col-sm-3 mb-3" sm={6} md={3} key={index}>

            <Card
              sx={{
                textAlign: "center",
                p: 2,
                borderTop: `5px solid ${item.color}`,
                borderRadius: 3,
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 12px 25px rgba(0,0,0,0.15)"
                }
              }}
            >

              <CardContent>

                <Box sx={{ color: item.color, mb: 1 }}>
                  {item.icon}
                </Box>

                <Typography variant="h6" fontWeight="bold" >
                  {item.title}
                </Typography>

               

                <Button
                  variant="contained"
                  sx={{
                    background: "#ff3b3b",
                    "&:hover": { background: "#d63030" },
                    marginTop:5
                  }}
                  onClick={() => navigate(item.link)}
                >
                  Open
                </Button>

              </CardContent>

            </Card>

          </Grid>

        ))}

      </Grid>

    </Box>
  );
}

export default Biometric;